import { useState } from "react";
import { Phone, MessageCircle, X } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { trackPhoneCall } from "@/lib/gtag";

const ContactPopup = () => {
  const [open, setOpen] = useState(false);
  const { lang } = useI18n();

  const handleToggle = () => {
    // Haptic vibration (mobile)
    if (navigator.vibrate) {
      navigator.vibrate(50);
    }
    // Click sound
    try {
      const ctx = new AudioContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = open ? 300 : 600;
      gain.gain.value = 0.08;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);
      osc.stop(ctx.currentTime + 0.12);
    } catch {}
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <div className="fixed z-50" style={{ right: "16px", bottom: "16px" }}>
      <div
        aria-hidden={!open}
        className={`absolute bottom-[calc(100%+0.75rem)] right-0 flex w-max flex-col gap-3 overflow-hidden transition-all duration-300 ${
          open
            ? "visible translate-y-0 opacity-100"
            : "pointer-events-none invisible translate-y-3 opacity-0"
        }`}
      >
        <a
          href="tel:+966115001577"
          onClick={trackPhoneCall}
          tabIndex={open ? 0 : -1}
          className={`flex items-center gap-3 rounded-2xl bg-navy px-5 py-3 text-cream shadow-xl transition-all duration-300 group hover:scale-105 hover:shadow-2xl ${
            open ? "translate-x-0 opacity-100 delay-75" : "translate-x-5 opacity-0"
          }`}
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cream/15 transition-colors group-hover:bg-cream/25">
            <Phone size={20} />
          </div>
          <div>
            <div className="text-sm font-bold">{lang === "ar" ? "اتصل بنا" : "Call Us"}</div>
            <div className="direction-ltr text-xs text-cream/60" dir="ltr">+966 11 500 1577</div>
          </div>
        </a>

        <a
          href="https://wa.me/966115001577"
          target="_blank"
          rel="noopener noreferrer"
          tabIndex={open ? 0 : -1}
          className={`flex items-center gap-3 rounded-2xl bg-[#25D366] px-5 py-3 text-white shadow-xl transition-all duration-300 group hover:scale-105 hover:shadow-2xl ${
            open ? "translate-x-0 opacity-100 delay-150" : "translate-x-5 opacity-0"
          }`}
        >
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/15 transition-colors group-hover:bg-white/25">
            <MessageCircle size={20} />
          </div>
          <div>
            <div className="text-sm font-bold">{lang === "ar" ? "واتساب" : "WhatsApp"}</div>
            <div className="direction-ltr text-xs text-white/70" dir="ltr">+966 11 500 1577</div>
          </div>
        </a>
      </div>

      <button
        type="button"
        aria-label={open ? "Close contact menu" : "Open contact menu"}
        aria-expanded={open}
        onClick={handleToggle}
        className={`relative flex h-14 w-14 items-center justify-center rounded-full shadow-2xl transition-all duration-300 active:scale-90 ${
          open
            ? "bg-navy/90 text-cream rotate-0"
            : "bg-cream text-navy animate-[pulse_2s_cubic-bezier(0.4,0,0.6,1)_infinite] ring-4 ring-cream/30"
        }`}
      >
        <span
          className={`absolute transition-all duration-200 ${
            open ? "rotate-0 scale-100 opacity-100" : "rotate-90 scale-75 opacity-0"
          }`}
        >
          <X size={24} />
        </span>
        <span
          className={`absolute transition-all duration-200 ${
            open ? "-rotate-90 scale-75 opacity-0" : "rotate-0 scale-100 opacity-100"
          }`}
        >
          <Phone size={24} />
        </span>
      </button>
    </div>
  );
};

export default ContactPopup;
